export const downloadPDFByUrl = async (url: string, name: string) => {
	const link = document.createElement('a');
	link.href = url;
	link.setAttribute('download', `${name}.pdf`);
	link.setAttribute('target', '_blank');
	document.body.appendChild(link);

	link.click();
	document.body.removeChild(link);
};
